export default __webpack_public_path__ + "static/media/summer.9bcfbe1b.jpg";